import Vue from 'vue'
import Vuex from 'vuex'

import GestAxios from './axios-auth'
import router from './router'

import * as moment from 'moment'

moment.locale('it')

Vue.use(Vuex)

// funzione per parsare il JWT
// mi serve per parsare la risposta
function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}


export default new Vuex.Store({
  state: {
    idtoken:null,
    userId:null,
    user:null,
    username:null,
    errorMsg:'',
    pagina:'Applicazione'
  },
  mutations: {
    authUser(state, userData){
      state.idtoken = userData.token;
      state.username    = userData.username;
      state.userId  = userData.userId;
    },
    setPagina(state, pagina){
      state.pagina = pagina
    },
    storeUser(state, user){
      state.user = user
    },
    storeError(state, errorMsg){
      state.errorMsg = errorMsg
    },
    clearAuthdata(state){
        state.idtoken= null
        state.userId = null
    }
  },
  actions: {
    tryAutoLogin({commit, dispatch}){
      const  token = localStorage.getItem('token')
      // console.log(token);
      if(!token){
          return
      }
      const expirationDate = new Date(localStorage.getItem('expirationDate'))
      //console.log(localStorage)
      const now = new Date()
      if(now >= expirationDate){
          return
      }
      const userId = localStorage.getItem('userId')
      const username = localStorage.getItem('username')
      // console.log(expirationDate.getTime()-now.getTime())
      commit('authUser', { token: token, userId: userId, username:username })
      dispatch('setLogoutTimer',expirationDate.getTime()-now.getTime())
    },
    setLogoutTimer({commit}, expirationTime){
      /* Faccio scadere la sessione con un timeout */
      // console.log("Expiration",  expirationTime)
      if (expirationTime > 2147483647){
        expirationTime = 2147483647
      }
      setTimeout(()=>{
          commit('clearAuthdata')
          router.replace('/login')
      }, expirationTime)
    },
    async login ({ commit, dispatch }, authData) {
      await GestAxios.post('/api-token-auth/', { username: authData.email, password: authData.password })
        .then(res => {
          const jwt = parseJwt(res.data.token)
          console.log(jwt)
          commit('authUser', { token: res.data.token, userId: jwt.user_id, username: jwt.username });
          // mi imposto la data di scadenza
          const nowOld = new Date('01/01/1970')
          // console.log(nowOld);
          // console.log(res.data.token)
          // non ho capito perchè
          const expirationDate = new Date(nowOld.getTime() + jwt.exp * 1000 + 60 * 60 * 1000);
          console.log(expirationDate);
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('expirationDate', expirationDate);
          localStorage.setItem('userId', jwt.user_id);
          localStorage.setItem('username', jwt.username);

          const now = new Date()
          const dateGap = expirationDate.getTime() - now.getTime()
          console.log(dateGap/1000);
          console.log(dateGap);
          // differenza di data
          dispatch('setLogoutTimer', dateGap)
          router.replace('/')
        })
        .catch(error => {
          console.log(error)
          if (error.data.non_field_errors){
            commit('storeError', error.data.non_field_errors[0] )
          }else{
            commit('storeError', 'Si è verificato un errore' )
          }

        })
    },
    storeErrors ({ commit }, myerror) {
      commit('storeError', myerror)
    },
    storeUser ({ commit, state }, userData) {
      if (!state.idtoken) {
        return
      }
      GestAxios.post('/user.json' + '?auth=' + state.idtoken, userData).then(res => {
        //console.log(res)
      }).catch(error => console.log(error))
    },
    fetchUser ({ commit, state }) {
      if (!state.idtoken) {
        // console.log(state.idtoken)
        return
      }
      GestAxios.get('/user.json' + '?auth=' + state.idtoken)
        .then(res => {
          // console.log(res)
          const data = res.data
          const users = []
          for (let key in data) {
            const user = data[key]
            user.id = key
            users.push(user)
          }
          // console.log(users)
          commit('storeUser', users[0])
        }).catch(error => { console.log(error) })
    },
    logout ({commit}) {
      commit('clearAuthdata')
      router.replace('/login')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
    }
  },
  getters: {
    getPagina (state){
      return state.pagina
    },
    getUsername (state) {
      return state.username
    },
    user (state) {
      return state.user
    },
    getUserId (state) {
      return state.userId
    },
    isAuthenticated (state) {
      // console.log("---> " + state.idtoken);
      return state.idtoken !== null
    },
    getMyToken (state) {
      // console.log(state)
      return state.idtoken
    },
    errors (state) {
      return state.errorMsg
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js